import React from 'react';

import { Spinner } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { DEFAULT_LOADER_SIZE } from './constants';
import { StyledWrapper } from './styled';

export interface ILoaderWrapperProps {
  height: number;
  size?: number;
}

export const Loader: ReactFCV<ILoaderWrapperProps> = ({ size = DEFAULT_LOADER_SIZE, ...props }) => (
  <StyledWrapper {...props}>
    <Spinner data-testid="spinner" color={'icon.primary'} size={size} />
  </StyledWrapper>
);
